import { useEffect, useState } from 'react';
import { Play } from 'lucide-react';
import api from '../../services/api';
import { useI18n } from '../../context/useI18n';
import ClassRecordingPreviewModal from '../live/ClassRecordingPreviewModal';

/**
 * Botón de video de bienvenida junto al título «Inicio» (usuarios finales D28D y sede).
 */
export default function WelcomeVideoHeaderButton() {
  const { t } = useI18n();
  const [ctx, setCtx] = useState(null);
  const [videoOpen, setVideoOpen] = useState(false);

  useEffect(() => {
    let active = true;
    api.get('/d28d/cycle/me')
      .then((r) => {
        if (active) setCtx(r.data?.data || null);
      })
      .catch(() => {
        if (active) setCtx(null);
      });
    return () => { active = false; };
  }, []);

  const startVideoUrl = String(
    ctx?.welcome_video_url
    || ctx?.cycle?.start_video_url
    || ctx?.cycle?.startVideoUrl
    || '',
  ).trim();

  if (!startVideoUrl) return null;

  const cycleName = ctx?.cycle?.name || t('d28d.cycle.current', 'Ciclo activo');

  return (
    <>
      <button
        type="button"
        className="btn btn-secondary text-xs sm:text-sm inline-flex items-center gap-1.5 shrink-0"
        onClick={() => setVideoOpen(true)}
      >
        <Play className="w-3.5 h-3.5" />
        {t('d28d.cycle.start_video', 'Video de bienvenida')}
      </button>
      {videoOpen ? (
        <ClassRecordingPreviewModal
          wide
          item={{
            title: t('d28d.cycle.start_video_modal_title', 'Bienvenida — {cycle}', { cycle: cycleName }),
            video_url: startVideoUrl,
          }}
          onClose={() => setVideoOpen(false)}
        />
      ) : null}
    </>
  );
}
